import { useHistory, useLocation } from "react-router-dom";

import { asLocation } from "seneca-common/utils/routing";
import { logSignUpEventByAccountType } from "seneca-common/utils/senecaAnalytics/events/signUp";

import { makeInternalRedirectState } from "features/common/routing/InternalRedirectOnlyRoute";
import { getRedirectAuthenticatedUserToLocation } from "features/sign-up/global-sign-up-modal/links";
import { userAccountType } from "features/user/consts";

export type Props = {
  accountType?: string;
  linkToNextPage?: string;
  isSSO?: boolean;
  search?: string;
};

export default function useOnSignUpSuccess({
  linkToNextPage,
  accountType,
  isSSO = false,
  search = ""
}: Props) {
  const history = useHistory();
  const location = useLocation();

  return () => {
    const redirectToCustomPageLink =
      getRedirectAuthenticatedUserToLocation(location);

    if (
      accountType &&
      accountType === userAccountType.schoolparent &&
      redirectToCustomPageLink &&
      !isSSO
    ) {
      logSignUpEventByAccountType(accountType);
      const nextLocation = asLocation(redirectToCustomPageLink);
      history.replace(nextLocation?.pathname + search, nextLocation?.state);
    } else {
      const redirectToDefaultPageLink = makeInternalRedirectState({
        pathname: linkToNextPage as any,
        state: location.state,
        search
      } as any);
      history.replace(redirectToDefaultPageLink);
    }
  };
}
